import ProspectsList from '../prospectsList';

function ProspectsListPage() {
  return <ProspectsList />;
}

export default ProspectsListPage;
